module.exports = __webpack_public_path__ + "img/criticalmass.2647edaa.svg";